import React from 'react'
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from 'react-bootstrap/Card';
import image29 from "../assests/image1.png";
import Image1 from "../assests/github-icon.png";
import Image2 from "../assests/link.png";
import Button from "react-bootstrap/Button";
import Saas1 from "../assests/saas1.png";
import Saas2 from "../assests/saas2.png";
import VB from "../assests/vb.png";
function extraworks() {
  return (
    <div style={{padidngTop:"20px"}} className="mb-5 mt-5">
      <Container>
        <center>
        <h2 className='text-white mb-3' data-aos="fade-up">Other works I have done</h2>
        <p className="color" data-aos="fade-left">Creative work</p>
        </center>
        <Row>
        <Col lg={4} md={6} sm={12}  data-aos="fade-up">
            <Card className='custom-card1 mb-5' style={{background:"#18245d",width:"100%"}}>
                <Card.Img
                  className='card-image1 but2'
                  variant='top'
                  src={Saas1}
                  style={{"border-radius":"10px",padding:"10px"}}
                />
                  <Card.Body >
                  <h4 className='fs-4 text-white mb-3 ' style={{fontWeight:"600"}}>Saas Application</h4>
                <p className="color2 font2"> Saas appliaction is able to work on the from the real time projects. This was a flexibility, accessibility, and collaboration features necessary to support real-time projects effectively. </p>
                <Row className="color3">
            <Col lg={3}>
             <p>React. js</p>
            </Col>
            <Col lg={5}>
             <p>React-Bootstarp</p>
            </Col>
            <Col lg={4}>
            <p>CSS</p>
            </Col>
            <Col lg={5}> 
            <p>Best-Performance</p>
            </Col>
            <Col lg={2}>
             <p>AOS</p>
            </Col>
            <Col lg={5}>
             <p>Responsive </p>
            </Col>
         </Row>
         <Row>
          <Col>
     <a href="https://github.com/ShaikMohammedGouse/" >    <Button className=" gap but1 rounded-pill px-4 font2" variant="outline-info"   style={{ "fontWeight": "700" }}>Github</Button>  </a>
          </Col>
          <Col>
          <a href="https://company-sites.netlify.com"> <Button className=" gap but1 rounded-pill px-4 font2" variant="outline-info"   style={{ "fontWeight": "700" }}>Go To </Button> </a>
          </Col>
         </Row>
                  </Card.Body>
              </Card>
            </Col>
            <Col lg={4} md={6} sm={12}  data-aos="fade-up">
            <Card className='custom-card1 mb-5' style={{background:"#18245d",width:"100%"}}>
                <Card.Img
                  className='card-image1  but2'
                  variant='top'
                  src={Saas2}
                  style={{"border-radius":"10px",padding:"15px 10px 10px 10px"}}
                />
                  <Card.Body >
                  <h4 className='fs-4 text-white mb-3 ' style={{fontWeight:"600"}}>Saas Application 2</h4>
                <p className="color2 font2"> Saas appliaction is able to work on the from the real time projects. This was a flexibility, accessibility, and collaboration features necessary to support real-time projects effectively.</p>
                <Row className="color3">
            <Col lg={3}>
             <p>React. js</p>
            </Col>
            <Col lg={5}>
             <p>React-Bootstarp</p>
            </Col>
            <Col lg={4}>
            <p>CSS</p>
            </Col>
            <Col lg={5}> 
            <p>Best-Performance</p>
            </Col>
            <Col lg={2}>
             <p>AOS</p>
            </Col>
            <Col lg={5}>
             <p>Responsive </p>
            </Col>
         </Row>
         <Row>
          <Col>
          <a href="https://github.com/ShaikMohammedGouse/" >    <Button className=" gap but1 rounded-pill px-4 font2" variant="outline-info"   style={{ "fontWeight": "700" }}>Github</Button>  </a>
          </Col>
          <Col>
          <a href="https://company-site2.netlify.com">  <Button className=" gap but1 rounded-pill px-4 font2" variant="outline-info"   style={{ "fontWeight": "700" }}>Go To </Button> </a>
          </Col>
         </Row>
                  </Card.Body>
              </Card>
            </Col>
              <Col lg={4} md={6} sm={12}  data-aos="fade-up">
            <Card className='custom-card1 mb-5' style={{background:"#18245d",width:"100%"}}>
                <Card.Img
                  className='card-image1 but2'
                  variant='top'
                  src={VB}
                  style={{"border-radius":"10px",padding:"10px"}}
                />
                  <Card.Body >
                  <h4 className='fs-4 text-white mb-3 ' style={{fontWeight:"600"}}>VB Enterprises</h4>
                <p className="color2 font2">VB Enterprises is a real time project for the making safety nets marketing websites.Marketing websites for safety nets could involve showcasing different types of safety nets, benefits,  safety regulations. </p>
                <Row className="color3">
            <Col lg={3}>
             <p>React. js</p>
            </Col>
            <Col lg={5}>
             <p>React-Bootstarp</p>
            </Col>
            <Col lg={4}>
            <p>CSS</p>
            </Col>
            <Col lg={5}> 
            <p>Best-Performance</p>
            </Col>
            <Col lg={2}>
             <p>AOS</p>
            </Col>
            <Col lg={5}>
             <p>Responsive </p>
            </Col>
         </Row>
         <Row>
          <Col>
          <a href="https://github.com/ShaikMohammedGouse/" >    <Button className=" gap but1 rounded-pill px-4 font2" variant="outline-info"   style={{ "fontWeight": "700" }}>Github</Button>  </a>
          </Col>
          <Col>
        <a href='https://vbsafetynets.in'>  <Button className=" gap but1 rounded-pill px-4 font2" variant="outline-info"   style={{ "fontWeight": "700" }}>Go To </Button> </a>
          </Col>
         </Row>
        
                  </Card.Body>
              </Card>
            </Col>
        </Row>
      </Container>
    </div>
  )
}

export default extraworks;
